import { Injectable} from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { GlobalMethodsService } from '../global-methods.service';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { StorageService } from './storage.service';
import { NavigationService } from './navigation.service';
import { GlobalVariablesService } from '../global-variables.service';
import { LocationService } from '../Location/location.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { CyberSafeguardSignal } from '../SicorService/RequestObject/CyberSafeguardSignal';
import { CyberSafeguardService } from './cyber-safeguard.service';
import { Installation } from 'src/app/models/Installation';
import { PanelConfService } from './panel-conf.service';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  public timerHandler = 0;
  public seconds = 0;
  //public title = '';
  public subtitle = '';
  public minutes = 0;
  public percent = 0;
  public outerStrokeColor = "#00AC7E";
  public innerStrokeColor = "#FFFFFF";
  public textColor ="#00AC7E";
  public title$: BehaviorSubject<string> = new BehaviorSubject('');
  public now: Date = new Date();
  public sendRequestParams: CyberSafeguardSignal;
  public timerCyberSafeguard = new Subject<{status: boolean, seconds: number, minutes: number}>();
  public accumulatedTime = 0;
  public pendingSeconds = 0;
  public counterSins = 0;
  public publicTimer = '';
  public lastSeconds: boolean = false;
  public $platformPause: any;
  public $platformResume: any;
  public isBackgroundActive = false;

  getTitleObs(): Observable<string> {
    return this.title$.asObservable();
  }

  setTitleObs(second: string) {
    this.title$.next(second);
  }

  constructor(
    private platform: Platform,
    public gms: GlobalMethodsService,
    private translate: TranslateConfigService,
    private modalCtrl: ModalController,
    private storage: StorageService,
    private navigation: NavigationService,
    public gvs: GlobalVariablesService,
    private locationService: LocationService,
    private cyberSafeguardService: CyberSafeguardService,
    private panelConfService: PanelConfService
  ) {
    this.timerCyberSafeguard.subscribe(async (response) => {
      if (response.status) {
        // await this.gms.loading();
        // const currentInstallation: Installation = this.gvs.currentInstallation;
        this.seconds = response.seconds;
        this.minutes = response.minutes / 60;
        if (!this.timerHandler) {
          await this.start(false);
          this.gms.setStatusTimerPanel(true);
        }
        // this.modalCtrl.dismiss(false, '', 'loadSpinner');
      }
    })
  }

  stop() {
    window.clearInterval(this.timerHandler);
    this.timerHandler = 0;
    this.publicTimer = '';
  }

  updatePublicTimer(){
    if (this.seconds >= 3600){
      this.publicTimer = new Date(this.seconds * 1000).toISOString().substr(11, 8);
    }else{
      this.publicTimer = new Date(this.seconds * 1000).toISOString().substr(14, 5);
    }
  }

  async start(restart = false) {
    await this.activeBackgroundMode();

    if (!restart) {
      await this.stop();
      // this.seconds = this.minutes * 60;
    }
    this.timerHandler = window.setInterval(async () => {
      this.seconds -= 1;
      this.updatePublicTimer();
      if (this.seconds <= 60) {
        this.lastSeconds = true;
        //this.title = this.seconds.toString();
        this.setTitleObs(this.seconds.toString());
        this.subtitle = await this.translate.getTranslate('CYBER-SAFEGUARD.seconds');
        if (this.seconds % 3 === 0 || this.seconds <= 10) {
          if (await this.platform.is('cordova')) {
            this.gms.hapticsImpact();
          }
        }
      } else {
        this.lastSeconds = false;
        //this.title = Math.ceil(this.seconds / 60).toString();
        this.setTitleObs(Math.ceil(this.seconds / 60).toString());
        this.subtitle = await this.translate.getTranslate('CYBER-SAFEGUARD.minutes');
      }
      if (this.seconds === 0) {
        await this.stop();
        this.modalCtrl.dismiss(false, '', 'countDownModal');
        //this.disabled = true;
        this.gms.setStatusTimerPanel(false);
        if (!this.isBackgroundActive || this.platform.is("desktop") || this.platform.is("mobileweb")) {
          await this.sendCyberSafeguardAlarm();
        }
      } else {
        this.percent = this.seconds / (this.minutes * 60) * 100;
        if (this.seconds < 60) {
          this.lastSeconds = true;
          this.outerStrokeColor = '#A0041E';
          this.innerStrokeColor = '#FFFFFF';
          this.textColor = '#FFFFFF';
        } else {
          this.lastSeconds = false;
          this.outerStrokeColor = '#00AC7E';
          this.innerStrokeColor = '#FFFFFF';
          this.textColor = '#00AC7E';
        }
      }
    }, 1000);
  }
  
  async sendCyberSafeguardAlarm() {
    this.gms.showLoading = true;
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      // await this.locationService.updateCurrentPosition('always');
      if (!this.platform.is("desktop") || !this.platform.is("mobileweb")){
        await this.locationService.updateLocation();
      }
      let geolocation: { [key: string]: number } = await this.storage.getObject('location');
      let date = new Date();
      const user = this.gvs.user.userName;
      this.sendRequestParams = {
        user: user,
        s_ins: this.counterSins,
        signal_id: 0,
        signal_desc: "",
        signal_lat: geolocation != null ? geolocation.latitude.toString() : '0',
        signal_long: geolocation != null ? geolocation.longitude.toString() : '0',
        signal_type: 0,
        signal_timer: 0,
        start_timer_dt: date.toISOString(),
      }
      try {
        let alarmSent = await this.cyberSafeguardService.sendCyberSafeguardSignal(this.sendRequestParams, 'countdown');
        this.deactivateBackgroundMode();
        if (alarmSent != undefined) {
          const installationsList = await this.storage.getObject(this.gvs.CONF_INSTALLATIONS + '_' + user);
          const objetiveInstallation = installationsList.find(x => x.s_ins == this.counterSins);
          this.gms.setChangeInstallationEvent(objetiveInstallation);
          this.gms.showLoading = false;
          await this.navigation.goTo("/alarm?screen=countdown");
          this.modalCtrl.dismiss(false, '', 'countDownModal');
        }
      }
      catch (e) {
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({ message: message });
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.alarmSetError'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  deactivateBackgroundMode(){
    if (this.$platformPause != null){
      this.$platformPause.unsubscribe();
    }
    if (this.$platformResume != null){
      this.$platformResume.unsubscribe();
    }
  }

  async activeBackgroundMode() {
    if (this.platform.is('cordova')) {

      this.$platformPause = this.platform.pause.subscribe(async () => {
        let currentDate = new Date();
        this.now = currentDate;
        this.pendingSeconds = this.seconds;
        this.isBackgroundActive = true;
      });

      this.$platformResume = this.platform.resume.subscribe(async () => {
        let currentDate = new Date();
        this.accumulatedTime = Math.trunc((currentDate.getTime() - this.now.getTime()) / 1000);
        if (this.pendingSeconds - this.accumulatedTime <= 0) {
          this.gms.setStatusTimerPanel(false);
          await this.stop();
          this.modalCtrl.dismiss(false, '', 'countDownModal');
          this.deactivateBackgroundMode();
          this.navigation.goHome();
        }else {
          this.seconds = this.pendingSeconds - this.accumulatedTime;
        }
        this.isBackgroundActive = false;
      });

    } 
  }

  /* Event start interval cybersafeguard
  ================================================== */
  public timerCyberSafeguardEvent({status, seconds, minutes}) {
    this.timerCyberSafeguard.next({status, seconds, minutes});
  }
}
